import { TasklistService } from '@/api/tasklist'
import { UserService } from '@/api/user'
import { DownloadButton } from '@/components/ui/Button'
import { Loading } from '@/components/ui/Loading'
import { CustomComponentContext } from '@/utils/contexts/CustomComponentContext'
import { useContext, useEffect } from 'react'

export default function MengisiLaporanKpiLeadershipVariableRenderer() {
  const { fieldSpec, taskData, setValue } = useContext(CustomComponentContext)
  const { data: user, isLoading: isLoadingProfile } = UserService.useGetProfile()
  const variables = taskData.variables || {}
  const { mutate, isLoading } = TasklistService.useDownloadFile()

  const displayRole = user?.role?.split(' ')[0]
  const isTim = user?.role?.includes('Tim') || user?.role?.includes('Staff')

  const handleClick = (urlDownload: string) => {
    mutate({ urlDownload: urlDownload, name: `Template KPI Leadership - ${displayRole}` })
  }

  useEffect(() => {
    if (user) {
      setValue('manager', user.manager)
      setValue('managerUsername', user.managerUsername)
      setValue('jobPosition', user.role)
    }
  }, [user, setValue])

  if (isLoadingProfile) return <Loading />

  return (
    <div className="border-2 border-[#c4c4c480] rounded-xl">
      <div className="flex flex-col p-4">
        <label className="text-lg sm:text-xl font-semibold mb-4" htmlFor={fieldSpec?.name}>
          Mengisi Laporan KPI Leadership
        </label>
        <div className="overflow-x-auto">
          <table className="table-auto w-full mx-auto" role="presentation">
            <tr>
              <td>Periode Bulan</td>
              <td>{taskData.variables.periodeBulan}</td>
            </tr>
            <tr>
              <td>Download Template KPI Leadership {isTim ? 'Tim' : 'Manager'}</td>
              <td className="pr-2 text-sm sm:text-md">
                <DownloadButton
                  className="h-fit"
                  onClick={() => handleClick(isTim ? variables.templateKpiLeadTim : variables.templateKpiLeadManajer)}
                  type="button"
                  size="small"
                  loading={isLoading}
                >
                  Download Template KPI Leadership - {displayRole}
                </DownloadButton>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  )
}
